export default __webpack_public_path__ + "static/media/banner-light.e0c0f7b6.jpg";